import MyIssuanceServices from "@/modules/MyIssuances/services/myIssuance.service";
import { ActionContext, ActionTree } from "vuex";
import {
  IMyFlightIssuance,
  IMyIssuanceState,
} from "@/core/interfaces/myIssuance.interface";
import { StoreState } from "@/store/type";
import { FetchBookingsParamsRequestModel } from "@/modules/MyBookings/models/fetchBookingsParams.request";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { StatusCodes } from "http-status-codes";

const actions: ActionTree<IMyIssuanceState, StoreState> = {
  async fetchMyIssuance(
    context: ActionContext<IMyIssuanceState, StoreState>,
    {
      payload,
      isFetchNewData,
      callBack,
    }: {
      payload: FetchBookingsParamsRequestModel;
      isFetchNewData: boolean;
      callBack?: () => void;
    },
  ) {
    context.commit("setMyIssuanceListLoading", true);
    context.commit("resetMyIssuanceList");

    try {
      const myIssuanceServices = new MyIssuanceServices();

      const response: IMyFlightIssuance =
        await myIssuanceServices.fetchMyIssuance(payload, isFetchNewData);
      context.commit("setMyIssuanceList", response);

      if (callBack) {
        callBack();
      }
    } catch (error) {
      context.commit("setMyIssuanceListLoading", false);
    } finally {
      context.commit("setMyIssuanceListLoading", false);
    }
  },
  async fetchMyIssuanceDetails(
    context: ActionContext<IMyIssuanceState, StoreState>,
    {
      issuanceId,
      organizationId,
    }: { issuanceId: string; organizationId: string },
  ) {
    context.commit("resetIssuanceDetails");
    try {
      const myIssuanceServices = new MyIssuanceServices();
      context.commit("setMyIssuanceDetailsLoading", true);
      const response: ICoreResponse =
        await myIssuanceServices.getMyIssuanceDetail(
          issuanceId,
          organizationId,
        );
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("setMyIssuanceDetails", response.data.data);
        context.commit("setMyIssuanceDetailsLoading", false);
      } else {
        notificationService.type = NOTIFICATION_TYPES.ERROR;
        notificationService.description = response.message || "";
        notificationService.triggerNotification();
      }
    } catch (err) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description =
        "Error while trying to fetch my issuance details ";
      notificationService.triggerNotification();
      context.commit("setMyIssuanceDetailsLoading", false);
    } finally {
      context.commit("setMyIssuanceDetailsLoading", false);
    }
  },
};

export default actions;
